export const firebaseConfig = {
    apiKey: 'AIzaSyBc-xn9Aiu2Z2GCwypHQrTuMqOIXdbOXHM',
    authDomain: "mtn-pulse-web.firebaseapp.com",
    projectId: 'mtn-pulse-web',
    storageBucket: 'mtn-pulse-web.appspot.com',
    messagingSenderId: '750400540346',
    appId: '1:750400540346:web:58e85c30062996913ebc83',
    measurementId: 'G-RMLXJ7G8DB',
  };
